import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';

import './Modal.scss';

interface DeleteTagModalProps {
  show: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

export const DeleteTagModal = ({ show, busy = false, onConfirm, onCancel, title, message }: DeleteTagModalProps) => {
  return (
    <BootstrapModal show={show} onHide={onCancel} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-trash tags-modal__tag-icon tags-modal__tag-icon--danger" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {title ?? i18n('tag.delete.modal.title')}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {message ?? i18n('tag.delete.modal.message')}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {i18n('tag.delete.modal.cancel')}
        </button>
        <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" disabled={busy} onClick={onConfirm}>
          {i18n('tag.delete.modal.confirm')}
        </button>
      </div>
    </BootstrapModal>
  );
};
